import { profiles } from "../misc/Static";
import calcData from "../memos/calcData";
import calcLanes from "../memos/calcLanes";
import styles from "./MatchNone.module.css";

export const MatchStandard = ({ puuid, data }) => {
  const pid = data ? data.puuid.indexOf(puuid) : false;
  const pOrder = calcLanes(data.lane, data.queue);
  const calc = calcData(data, pOrder, pid, profiles.queues);

  return (
    <>
      <div className={styles.victory}>
        <div className={styles.meta}>
          <div>{calc.queue}</div>
        </div>
      </div>
    </>
  );
};
export default MatchStandard;
